import { render } from "solid-js/web";
import { Router, Routes, Route, hashIntegration } from "@solidjs/router";
import { DashboardRoute } from "./components/dashboard/dashboard";
import { DeviceSetupRoute } from "./components/device/setup";
import { AccountsRoute } from "./components/accounts/accounts";

const App = () => {
  return <Routes>
      <Route path="/" component={DashboardRoute} />
      <Route path="/device/:uuid/setup" component={DeviceSetupRoute} />
      <Route path="/accounts" component={AccountsRoute} />
    </Routes>
}


export function attachApp() {
  render(() => <Router source={hashIntegration()}><App /></Router>, document.getElementById('app'));
}

attachApp();